import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'default',
    component:() => import('../views/default.vue')
  },
  {
    path: '/userdetail',
    name: 'userdetail',
    component: () => import('../views/userdetail.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
    props({ query }) {
      return { code: query.code} //用组件参数的形式把query传递给组件
    },
  },
  {
    path: '/mesmain',
    name: 'mesmain',
    meta: { title: '生产进度' },
    component: () => import('../views/mes/main.vue')
  },
  {
    path: '/moreport',
    name: 'moreport',
    meta: { title: '工序报工' },
    component: () => import('../views/mes/moreport.vue')
  },
  {
    path: '/moreportlist',
    name: 'moreportlist',
    meta: { title: '报工记录' },
    component: () => import('../views/mes/moreportlist.vue')
  },
  {
    path: '/moreportdetail',
    name: 'moreportdetail',
    meta: { title: '工序汇报详细' },
    component: () => import('../views/mes/moreportdetail.vue'),
    props({ query }) {
      return { billno: query.billno} //用组件参数的形式把query传递给组件
    },
  },
  {
    path: '/taskreport',
    name: 'taskreport',
    meta: { title: '派工单报工' },
    component: () => import('../views/mes/taskreport.vue')
  },
  {
    path: '/taskreportlist',
    name: 'taskreportlist',
    meta: { title: '派工单报工记录' },
    component: () => import('../views/mes/taskreportlist.vue')
  },
  {
    path: '/prdinspect',
    name: 'prdinspect',
    meta: { title: '生产检验' },
    component: () => import('../views/mes/prdinspect.vue')
  },
  {
    path: '/prdinspectlist',
    name: 'prdinspectlist',
    meta: { title: '生产检验记录' },
    component: () => import('../views/mes/prdinspectlist.vue')
  },
  {
    path: '/inspect',
    name: 'inspect',
    meta: { title: '来料检验' },
    component: () => import('../views/mes/inspect.vue'),
    props({ query }) {
      return { qrcode:query.qrcode}
    },
  },
  {
    path: '/inspectlist',
    name: 'inspectlist',
    meta: { title: '来料检验记录' },
    component: () => import('../views/mes/inspectlist.vue')
  },
  {
    path: '/inspecttask',
    name: 'inspecttask',
    meta: { title: '来料检验任务' },
    component: () => import('../views/mes/inspecttask.vue'),
    props({ query }) {
      return { billno: query.billno,qrcode:query.qrcode} 
    },
  },
  {
    path: '/inspecttasklist',
    name: 'inspecttasklist',
    meta: { title: '来料检验任务' },
    component: () => import('../views/mes/inspecttasklist.vue')
  },  
  {
    path: '/prdinspecttask',
    name: 'prdinspecttask',
    meta: { title: '生产检验任务' },
    component: () => import('../views/mes/prdinspecttask.vue'),
    props({ query }) {
      return { billno: query.billno,qrcode:query.qrcode} 
    },
  },
  {
    path: '/prdinspecttasklist',
    name: 'prdinspecttasklist',
    meta: { title: '生产检验任务' },
    component: () => import('../views/mes/prdinspecttasklist.vue')
  },  
  {
    path: '/salinspecttask',
    name: 'salinspecttask',
    meta: { title: '出库检验任务' },
    component: () => import('../views/mes/salinspecttask.vue'),
    props({ query }) {
      return { billno: query.billno,qrcode:query.qrcode} 
    },
  },
  {
    path: '/salinspecttasklist',
    name: 'salinspecttasklist',
    meta: { title: '出库检验任务' },
    component: () => import('../views/mes/salinspecttasklist.vue')
  },
  {
    path: '/salosinspectlist',
    name: 'salosinspectlist',
    meta: { title: '出库检验记录' },
    component: () => import('../views/mes/salosinspectlist.vue')
  },
  {
    path: '/dailyinspect',
    name: 'dailyinspect',
    meta: { title: '日常检验' },
    component: () => import('../views/mes/dailyinspect.vue'),
    // props({ query }) {
    //   return { qrcode:query.qrcode}
    // },
  },
  {
    path: '/equdjtask',
    name: 'equdjtask',
    meta: { title: '设备点检' },
    component: () => import('../views/mes/equdjtask.vue')
  },
  {
    path: '/equdjtasklist',
    name: 'equdjtasklist',
    meta: { title: '点检记录' },
    component: () => import('../views/mes/equdjtasklist.vue')
  },
  {
    path: '/equbytask',
    name: 'equbytask',
    meta: { title: '设备保养' },
    component: () => import('../views/mes/equbytask.vue')
  },
  {
    path: '/equbytasklist',
    name: 'equbytasklist',
    meta: { title: '保养记录' },
    component: () => import('../views/mes/equbytasklist.vue')
  },
  {
    path: '/equwxtask',
    name: 'equwxtask',
    meta: { title: '设备维修' },
    component: () => import('../views/mes/equwxtask.vue'),
    props({ query }) {
      return { billno: query.billno} 
    }
  },
  {
    path: '/equwxtaskedit',
    name: 'equwxtaskedit',
    meta: { title: '设备维修' },
    component: () => import('../views/mes/equwxtaskedit.vue'),
    props({ query }) {
      return { billno: query.billno} 
    }
  },
  {
    path: '/equhistory',
    name: 'equhistory',
    meta: { title: '设备履历' },
    component: () => import('../views/mes/equhistory.vue')
  },
  {
    path: '/equwxtasklist',
    name: 'equwxtasklist',
    meta: { title: '保养记录' },
    component: () => import('../views/mes/equwxtasklist.vue')
  },
  {
    path: '/moldbytask',
    name: 'moldbytask',
    meta: { title: '模具保养' },
    component: () => import('../views/mes/moldbytask.vue')
  },
  {
    path: '/moldbytasklist',
    name: 'moldbytasklist',
    meta: { title: '保养记录' },
    component: () => import('../views/mes/moldbytasklist.vue')
  },
  {
    path: '/moldwxtask',
    name: 'moldwxtask',
    meta: { title: '模具维修' },
    component: () => import('../views/mes/moldwxtask.vue'),
    props({ query }) {
      return { billno: query.billno} 
    }
  },
  {
    path: '/moldwxtasklist',
    name: 'moldwxtasklist',
    meta: { title: '维修记录' },
    component: () => import('../views/mes/moldwxtasklist.vue')
  },
  {
    path: '/moldwxtaskedit',
    name: 'moldwxtaskedit',
    meta: { title: ' 模具维修' },
    component: () => import('../views/mes/moldwxtaskedit.vue'),
    props({ query }) {
      return { billno: query.billno} 
    }
  },
  {
    path: '/moldoutstock',
    name: 'moldoutstock',
    meta: { title: '模具领用' },
    component: () => import('../views/mes/moldoutstock.vue')
  },
  {
    path: '/moldoutstocklist',
    name: 'moldoutstocklist',
    meta: { title: '领用记录' },
    component: () => import('../views/mes/moldoutstocklist.vue')
  },
  {
    path: '/moldinstock',
    name: 'moldinstock',
    meta: { title: '模具入库' },
    component: () => import('../views/mes/moldinstock.vue')
  },
  {
    path: '/moldinstocklist',
    name: 'moldinstocklist',
    meta: { title: '入库记录' },
    component: () => import('../views/mes/moldinstocklist.vue')
  },
  {
    path: '/moldhistory',
    name: 'moldhistory',
    meta: { title: '模具履历' },
    component: () => import('../views/mes/moldhistory.vue')
  },
  {
    path: '/sopdetail',
    name: 'sopdetail',
    meta: { title: 'SOP文件' },
    component: () => import('../views/mes/sopdetail.vue'),
    props({ query }) {
      return { mnumber: query.mnumber,qrcode:query.qrcode} //用组件参数的形式把query传递给组件
    },
  },
  {
    path: '/soplist',
    name: 'soplist',
    meta: { title: '查询SOP' },
    component: () => import('../views/mes/soplist.vue'),
    props({ query }) {
      return { qrcode:query.qrcode} //用组件参数的形式把query传递给组件
    },
  },
  {
    path: '/inspectsop',
    name: 'inspectsop',
    meta: { title: 'SOP文件' },
    component: () => import('../views/mes/inspectsop.vue'),
    props({ query }) {
      return { mnumber: query.mnumber,qrcode:query.qrcode,tasktype:query.tasktype} //用组件参数的形式把query传递给组件
    },
  },
  {
    path: '/abnormal',
    name: 'abnormal',
    meta: { title: '异常申报' },
    component: () => import('../views/mes/abnormal.vue')
  },
  {
    path: '/abnormallist',
    name: 'abnormallist',
    meta: { title: '异常申报记录' },
    component: () => import('../views/mes/abnormallist.vue')
  },
  {
    path: '/abnormaldetail',
    name: 'abnormaldetail',
    meta: { title: '异常申报' },
    component: () => import('../views/mes/abnormaldetail.vue'),
    props({ query }) {
      return { billno: query.billno} 
    }
  },
  {
    path: '/abnormalselect',
    name: 'abnormalselect',
    meta: { title: '申报单选择' },
    component: () => import('../views/mes/abnormalselect.vue'),
    props({ query }) {
      return { url: query.url} 
    }
  },
  {
    path: '/abnormalhandle',
    name: 'abnormalhandle',
    meta: { title: '异常处理' },
    component: () => import('../views/mes/abnormalhandle.vue'),
    props({ query }) {
      return { billno: query.billno} 
    }
  },
  {
    path: '/abnormalhandlelist',
    name: 'abnormalhandlelist',
    meta: { title: '异常处理记录' },
    component: () => import('../views/mes/abnormalhandlelist.vue')
  },
  {
    path: '/abnormalhandleedit',
    name: 'abnormalhandleedit',
    meta: { title: '异常处理' },
    component: () => import('../views/mes/abnormalhandleedit.vue'),
    props({ query }) {
      return { billno: query.billno} 
    }
  },
  {
    path: '/gysmain',
    name: 'gysmain',
    meta: { title: '供应商协同' },
    component: () => import('../views/supplier/main.vue')
  },
  {
    path: '/purorderlist',
    name: 'purorderlist',
    meta: { title: '采购订单' },
    component: () => import('../views/supplier/purorderlist.vue'),
    props({ query }) {
      return { billno: query.billno, number: query.number} 
    }
  },
  {
    path: '/jjpurorderlist',
    name: 'jjpurorderlist',
    meta: { title: '加急采购订单' },
    component: () => import('../views/supplier/jjpurorderlist.vue'),
    props({ query }) {
      return { billno: query.billno, number: query.number} 
    }
  },
  {
    path: '/purorderdetail',
    name: 'purorderdetail',
    meta: { title: '采购订单详细' },
    component: () => import('../views/supplier/purorderdetail.vue'),
    props({ query }) {
      return { billno: query.billno, number: query.number} 
    }
  },
  {
    path: '/purreceiveedit',
    name: 'purreceiveedit',
    meta: { title: '送货详细' },
    component: () => import('../views/supplier/purreceiveedit.vue'),
    props({ query }) {
      return { billno: query.billno, number: query.number,tasktype:query.tasktype} 
    }
  },
  {
    path: '/purreceivelist',
    name: 'purreceivelist',
    meta: { title: '送货单列表' },
    component: () => import('../views/supplier/purreceivelist.vue'),
    props({ query }) {
      return {  number: query.number} 
    }
  },
  {
    path: '/purreceivedetail',
    name: 'purreceivedetail',
    meta: { title: '送货单详细' },
    component: () => import('../views/supplier/purreceivedetail.vue'),
    props({ query }) {
      return { billno: query.billno, number: query.number} 
    }
  },
  {
    path: '/materialselect',
    name: 'materialselect',
    meta: { title: '物料选择器' },
    component: () => import('../views/supplier/materialselect.vue'),
    props({ query }) {
      return { number: query.number} 
    }
  },
  {
    path: '/appayablelist',
    name: 'appayablelist',
    meta: { title: '入库单列表' },
    component: () => import('../views/supplier/appayablelist.vue'),
    props({ query }) {
      return { number: query.number} 
    }
  },
  {
    path: '/statementlist',
    name: 'statementlist',
    meta: { title: '对账单' },
    component: () => import('../views/supplier/statementlist.vue')
  },
  {
    path: '/statementedit',
    name: 'statementedit',
    meta: { title: '对账单详细' },
    component: () => import('../views/supplier/statementedit.vue'),
    props({ query }) {
      return { billno: query.billno} 
    }
  },
  {
    path: '/quoteedit',
    name: 'quoteedit',
    meta: { title: '供价表' },
    component: () => import('../views/supplier/quoteedit.vue'),
  },
  {
    path: '/reconciliationlist',
    name: 'reconciliationlist',
    meta: { title: '对账单' },
    component: () => import('../views/supplier/reconciliationlist.vue'),
    props({ query }) {
      return { number: query.number} 
    }
  },
  {
    path: '/svminquirylist',
    name: 'svminquirylist',
    meta: { title: '询价单' },
    component: () => import('../views/supplier/svminquirylist.vue'),
    props({ query }) {
      return { number: query.number} 
    }
  },
  {
    path: '/svminquirydetail',
    name: 'svminquirydetail',
    meta: { title: '询价单详细' },
    component: () => import('../views/supplier/svminquirydetail.vue'),
    props({ query }) {
      return { billno: query.billno, number: query.number} 
    }
  },
  {
    path: '/svmquoteedit',
    name: 'svmquoteedit',
    meta: { title: '报价单详细' },
    component: () => import('../views/supplier/svmquoteedit.vue'),
    props({ query }) {
      return { billno: query.billno} 
    }
  },
  {
    path: '/purmrblist',
    name: 'purmrblist',
    meta: { title: '采购退料单(检验)' },
    component: () => import('../views/supplier/purmrblist.vue'),
    props({ query }) {
      return { number: query.number} 
    }
  },
  {
    path: '/bulletinlist',
    name: 'bulletinlist',
    meta: { title: '企业公告' },
    component: () => import('../views/supplier/bulletinlist.vue'),
    props({ query }) {
      return { number: query.number} 
    }
  },
  {
    path: '/bulletindetail',
    name: 'bulletindetail',
    meta: { title: '企业公告详细' },
    component: () => import('../views/supplier/bulletindetail.vue'),
    props({ query }) {
      return { billno: query.billno} 
    }
  },
  {
    path: '/purmrbdetail',
    name: 'purmrbdetail',
    meta: { title: '采购退料单(检验)详细' },
    component: () => import('../views/supplier/purmrbdetail.vue'),
    props({ query }) {
      return { billno: query.billno, number: query.number} 
    }
  },
  {
    path: '/reconciliationedit',
    name: 'reconciliationedit',
    meta: { title: '对账单详细' },
    component: () => import('../views/supplier/reconciliationedit.vue'),
    props({ query }) {
      return { billno: query.billno, number: query.number} 
    }
  },
  {
    path: '/salarydetail',
    name: 'salarydetail',
    meta: { title: '个人工资条' },
    component: () => import('../views/mes/salarydetail.vue')
  }
  ,
  {
    path: '/supplierpoolreg',
    name: 'supplierpoolreg',
    meta: { title: '供应商登记' },
    component: () => import('../views/supplier/supplierpoolreg.vue'),
    props({ query }) {
      return { code: query.code} 
    }
  },
  {
    path: '/supplierpoolreglist',
    name: 'supplierpoolreglist',
    meta: { title: '登记记录' },
    component: () => import('../views/supplier/supplierpoolreglist.vue')
  },
  {
    path:'/supplierassresportlist',
    name:'supplierassresportlist',
    meta: { title: '评估记录' },
    component: () => import('../views/supplier/supplierassresportlist.vue')
  },
  {
    path: '/supplierassresport',
    name: 'supplierassresport',
    meta: { title: '供应商评估报告' },
    component: () => import('../views/supplier/supplierassresport.vue'),
    props({ query }) {
      return { billno: query.billno} 
    }
  },{
    path: '/defectiveprdlist',
    name: 'defectiveprdlist',
    meta: { title: '不良品列表' },
    component: () => import('../views/mes/defectiveprdlist.vue')
  },{
    path: '/defectiveprdedit',
    name: 'defectiveprdedit',
    meta: { title: '不良品编辑' },
    component: () => import('../views/mes/defectiveprdedit.vue'),
    props({ query }) {
      return { billno: query.billno} 
    }
  },  
  {   
    path: '/6sinspecttasklist',
    name: '6sinspecttasklist',
    meta: { title: '6S巡检任务' },
    component: () => import('../views/mes/6sinspecttasklist.vue')
  },
  {
    path: '/6sinspecttaskdetail',
    name: '6sinspecttaskdetail',
    meta: { title: '6S巡检任务详细' },
    component: () => import('../views/mes/6sinspecttaskdetail.vue'),
    props({ query }) {
      return { billno: query.billno} 
    }
  }
  // ,
  // {
  //   path: '/VideoCompressor',6sinspecttasklist
  //   name: 'VideoCompressor',
  //   meta: { title: '视频压缩' },
  //   component: () => import('../views/mes/VideoCompressor.vue')
  // }  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
